import { SxProps } from "@mui/material";

export const sxMyGuidesCard: SxProps = {
    fontFamily: 'UnimedSans-Bold',
    borderRadius: '80px',
    padding: '12px 32px ',
    minWidth: '210px',
    width: 'auto',
}

export const sxButtonDetail: SxProps = {
    fontFamily: 'Unimed-Sans',
    borderRadius: '80px',
    padding: '12px 12px ',
    width: 'auto',
    textDecoration:'underline',
    textTransform:'none',
    fontWeight:'bold',
    color: '#156D44',
    '&:hover': {
        color: '#164029',
        textDecoration:'underline',
    },
}

export const sxLabel: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontWeight: 600,
    marginBottom: '5px'
}

export const sxButton: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px',
    '@media (max-width:1200px)': {
        width: '100%',
    },
}

export const sxCalendar: SxProps = {

    width: '100%',
    ".MuiDateCalendar-root": {
        backgroundColor: '#00995D',
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08);'
    },
    ".MuiPickersCalendarHeader-root": {
        backgroundColor: '#00995D',
        color: '#fff',
        textTransform: 'uppercase',
        borderRadius: '10px 10px 0px 0px',
        paddingTop: '15px',
        paddingBottom: '15px',
        margin: '0',
        maxHeight: 'none',
    },
    ".MuiPickersCalendarHeader-labelContainer": {
        fontFamily: 'Unimed-Sans',
        fontWeight: '700',

    },
    ".MuiDayCalendar-root": {
        backgroundColor: "#fff"
    },
    ".MuiPickersCalendarHeader-switchViewButton": {
        color: '#fff'
    },
    ".MuiPickersArrowSwitcher-button": {
        color: '#fff'
    },
    ".MuiDayCalendar-weekDayLabel": {
        fontFamily: 'Unimed-Sans',
        fontWeight: '700',
        color: '#4C4C4C'
    },
    ".MuiPickersDay-root": {
        fontFamily: 'Unimed-Sans',
        color: '#4C4C4C',
        backgroundColor: '#fff'
    },
    "MuiPickersDay-root:focus": {
        backgroundColor: '#00995D'
    },
    "MuiPickersDay-root:hover": {
        backgroundColor: '#000'
    },
    ".MuiPickersYear-yearButton": {
        fontFamily: 'Unimed-Sans',
        color: '#4C4C4C'
    },
    ".Mui-selected": {
        backgroundColor: '#00995D',
        color: "#fff"
    },
    ".Mui-selected:focus": {
        backgroundColor: '#00995D'
    },
    ".Mui-selected:hover": {
        backgroundColor: '#00995D'
    },
    ".Mui-disabled": {
        background: 'none'
    },
    '.MuiButton:hover .MuiButton-contained': {
        backgroundColor: '#00995D',
    }
}

export const sxCalendarContrast: SxProps = {
    ...sxCalendar,
      '& .MuiInputBase-root': {
        backgroundColor: 'black',
        color: 'white',
      },
      '& .MuiSvgIcon-root': {
        color: 'white',
      },
  }


  export const sxButtonText: SxProps = {
    textDecoration: 'none',
    textTransform: 'none',
    fontFamily: 'Unimed-Sans',
    fontWeight: 300,
    padding: 0,
    '&:hover': {
        textDecoration: 'none',
        color: 'inherit',
    }
}

export const sxInput: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontWeight: 400,
    fontSize: '14px'
}
